module.exports = __webpack_public_path__ + "img/icon_03.74bb802.png";